<template>
    
        
            <div>
				
				<b-link href="/register/seller"> <b-img :src="$root.MEDIAPATH+'banners/Strip-Call-Out-Banner-01.png'" class="w-100"></b-img></b-link>
                <!--<b-row class="align-items-center">
                    <b-col cols lg="9" class="font-weight-bold">
                        <span class="line-1">
                            LIST YOUR BRAND
                        </span> <br/>
                         <span class="line-2">
                            OPEN YOUR OWN STORE IN JUST 5 MINUTES
                        </span><br/>
                         <span class="line-3">
                           START SELLING FROM TODAY
                        </span>
                    </b-col>
                    <b-col cols lg="3" class=" d-flex align-items-center justify-content-center" >
                        <b-button size="lg" class="register" >Register Now</b-button>
                    </b-col>
                </b-row> -->
            </div>
        
    
</template>
<script>
export default {

}
</script>
<style>
   /* .banner {
        background: #A585BC;
        color: black;
    }
    .line-1, .line-2, .line-3 {
        font-size: 20px;
    }
    .line-2 {
        font-size: 30px;
        color: white;
		letter-spacing: 3px;
    }
    .line-3 {
        float: right;
		margin-right: 54px;
    }
    .banner .register {
        background: #7954A1 !important;
        color: white !important;
    } */
</style>